module.exports = __webpack_public_path__ + "img/bank-transfers-2.f72910ce.svg";